import { isShowEvent } from 'src/config/event/utils';
import { SampleGptButton } from '../SampleGptButton';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/gpt/games';
import { useModalContext } from 'src/hooks/useModalContext';
import { LuckyCardEventIcon } from 'src/config/assets/gptEventIcons/LuckyCardEventIcon';

export const LuckyCardButton = () => {
  const { openModal } = useModalContext();
  const isGptGamesEvent = isShowEvent('GPT_GAMES');

  return (
    <GPTGameLauncher
      gameName="cardGame"
      renderButton={({ Icon, ...props }) => (
        <SampleGptButton
          Icon={isGptGamesEvent ? LuckyCardEventIcon : Icon}
          {...props}
          title="gptButtons.luckyCardTitle"
        />
      )}
      openRegistration={() => openModal('SIGNUP')}
    />
  );
};
